import Hero from "@/components/Hero";
import StatsBand from "@/components/StatsBand";
import ServicesGrid from "@/components/ServicesGrid";
import FounderSection from "@/components/FounderSection";
import ValuesBento from "@/components/ValuesBento";
import FoundationSection from "@/components/FoundationSection";
import PartnersMarquee from "@/components/PartnersMarquee";
import HealthcareNewsFeed from "@/components/HealthcareNewsFeed";
import CTABand from "@/components/CTABand";

export default function Home() {
  return (
    <div data-testid="page-home">
      <Hero />
      <StatsBand />
      <ServicesGrid />
      <FounderSection />
      <PartnersMarquee />
      <HealthcareNewsFeed compact={true} limit={5} />
      <ValuesBento />
      <FoundationSection />
      <CTABand />
    </div>
  );
}
